import {FC} from 'react';
import {HeadingWithDecoration} from '../../common/HeadingWithDecoration';

export const AdminPage: FC = () => {
  return <HeadingWithDecoration text="Admin" />;
};
